module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_external_link_white-63e47a58a00cc56856dbdf9cc92b4f1d.svg";